// src/pages/Partners.tsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import ContactForm from '../../components/LandingPage/ContactForm/ContactForm';
import Footer from '../../components/LandingPage/Footer/Footer';

export default function Partners() {
  const { t } = useTranslation();

  // Al montar el componente, se hace scroll hasta el inicio.
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-b from-black via-[#0A192F] to-[#060D1B] text-white">
      <div className="container mx-auto px-6 py-24 max-w-6xl">
        
        {/* Título principal */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-center mb-10 mt-14">
          {t('partners.title')}
        </h1>

        {/* Texto de introducción */}
        <div className="mb-12 max-w-3xl mx-auto text-center">
          <p className="text-lg md:text-xl text-gray-300 mb-4">
            {t('partners.intro')}
          </p>
          <p className="text-lg md:text-xl text-gray-300">
            {t('partners.contact_prompt')}
          </p>
        </div>


        {/* Formulario de Contacto */}
        <h2 className="text-2xl font-bold text-center mb-4">
          {t('home.request_registration')}
        </h2>
        <div className="max-w-6xl mx-auto">
          <ContactForm className="w-full" hideFAQLink={false} />
        </div>
      </div>

      <Footer/>
    </main>
  );
}
